import React, { forwardRef } from "react";
import serjusHeader from "../../assets/header-contrato/header-contrato.png";

const CartaInstitucionalReconocimiento = forwardRef(({ data }, ref) => {
    const fechaFormateada = data.fecha
        ? (() => {
            const [anio, mes, dia] = data.fecha.split("-");
            return `${dia}-${mes}-${anio}`;
        })()
        : "_____/_____/_____";

    const descripcionLarga =
        data.descripcionReconocimiento?.length > 500;

    return (
        <>
            <style>{`
        @page { margin: 1.5cm; }

        body, p {
          font-family: 'Arial Narrow', Arial, sans-serif !important;
          font-size: 12pt !important;
          line-height: 1.3 !important;
        }

        #lineprintable,
        #printable {
            font-family: "Times New Roman", serif;
            font-size: 11pt;
            line-height: 1.6;
            text-align: justify;
        }

        #printable p {
            margin: 0 0 8pt 0;
        }

        #printable h1 {
            font-size: 14pt;
            margin-bottom: 18pt;
        }

        .input-field {
          background-color: rgba(255, 215, 0, 0.6);
          border-bottom: 1px solid #FFD700;
          padding: 0 2px;
        }

        .checkbox-item {
            margin-bottom: 2px;
            line-height: 1.2;
        }

        @media print {
          .input-field {
            background: none !important;
            border: none !important;
            box-shadow: none !important;
          }
        }

        @media print {
            .firma-section {
                page-break-inside: avoid !important;
                break-inside: avoid !important;
            }
        }
      `}</style>

            <div style={pageStyle}>
                <div
                    id="printable"
                    ref={ref}
                    style={{
                        minHeight: "100%",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    {/* Encabezado */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            marginBottom: "10px",
                        }}
                    >
                        <img
                            src={serjusHeader}
                            alt="SERJUS"
                            style={{
                                width: "100%",
                                maxHeight: "110px",
                                objectFit: "contain",
                            }}
                        />
                    </div>

                    <h1
                        style={{
                            textAlign: "center",
                            marginBottom: "25px",
                        }}
                    >
                        CARTA INSTITUCIONAL DE RECONOCIMIENTO
                    </h1>

                    {/* Fecha */}
                    <p style={{ textAlign: "right", marginBottom: "25px" }}>
                        <span className="input-field">
                            {data.lugar || "Quetzaltenango"}
                        </span>
                        ,{" "}
                        <span className="input-field">
                            {data.fecha
                                ? data.fecha.split("-").reverse().join("-")
                                : "_____/_____/_____"}
                        </span>
                    </p>

                    <p>
                        La presente tiene como propósito expresar nuestro
                        reconocimiento institucional a:
                    </p>

                    <p>
                        <span className="input-field">
                            {data.nombreEmpleado || "________________________________"}
                        </span>
                        {" - "}
                        <span className="input-field">
                            {data.puesto || "____________________________"}
                        </span>
                    </p>
                    <p>
                        <strong>Por su:</strong>
                    </p>

                    <div
                        style={{
                            whiteSpace: "pre-line",
                            marginLeft: "20px",
                            marginBottom: "20px",
                            textTransform: "uppercase",
                        }}
                    >
                        <span className="input-field">
                            {data.motivosReconocimiento}
                        </span>
                    </div>

                    <p>
                        evidenciado durante el desarrollo de sus labores.
                    </p>

                    <p style={{ marginTop: "10px" }}>
                        <strong>Se reconoce especialmente:</strong>
                    </p>

                    <div
                        style={{
                            fontSize: descripcionLarga
                                ? "12pt"
                                : "12pt",
                        }}
                    >
                        <span className="input-field">
                            {data.descripcionReconocimiento ||
                                "Ingrese aquí la descripción del reconocimiento otorgado."}
                        </span>
                    </div>

                    <p style={{ marginTop: "30px" }}>
                        Por lo cual, la organización agradece profundamente
                        su esfuerzo y el aporte brindado al cumplimiento
                        de nuestra misión institucional y al acompañamiento
                        de las comunidades y procesos organizativos.
                    </p>

                    <p style={{ marginTop: "10px" }}>
                        Atentamente,
                    </p>

                    {/* Firma */}
                    <div
                        style={{
                            marginTop: "40px",
                            textAlign: "center",
                            pageBreakInside: "avoid",
                            breakInside: "avoid",
                        }}
                    >
                        <p style={{ marginBottom: "10px" }}>
                            Firma: ________________________
                        </p>
                        <span className="input-field">
                            {data.nombreResponsable ||
                                "____________________________"}
                        </span>
                        <br />
                        <span className="input-field">
                            {data.cargoResponsable ||
                                "____________________________"}
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
});

const pageStyle = {
    width: "100%",
    background: "#fff",
    margin: 0,
    padding: "0 0 0 30px",
    boxSizing: "border-box",
};

export default CartaInstitucionalReconocimiento;